import { Component, Input } from '@angular/core';
import { IPerformanceMonthlyWidths } from '../revenue-widget.component';
import { Performance } from 'county-api';

@Component({
    selector: 'revenue-location',
    templateUrl: './revenue-location.component.html',
    styleUrls: ['./revenue-location.component.scss'],
})
export class RevenueLocationComponent {
    @Input()
    locationPerformanceData: IPerformanceMonthlyWidths;

    @Input()
    targetDetail : Performance.IPerformanceTarget | null;

    @Input()
    showEstimate: boolean;

    get goodTarget(){
        if (this.targetDetail){
            return this.targetDetail.good_target;
        }

        return 0;
    }

    get greatTarget(){
        if (this.targetDetail){
            return this.targetDetail.great_target;
        }

        return 0;
    }
}
